window.addEventListener("load", () => {
  const parentList = document.querySelector(".m-link-lists-ul");
  const blogTagBtns = document.querySelectorAll(".m-link-lists--item-blog");

  blogTagBtns.forEach((tag, idx) => {
    if (tag.id === "") {
      tag.id = `m-list__id-${idx}`;
    }
    const text = tag.textContent.trim();
    if (text.includes("Conditions")) {
      tag.style.backgroundColor = "#01556A";
      tag.children[0].style.color = "#FFA73F";
    }
    if (text === "Medical") {
      tag.style.display = "None";
    }
  });

  const currentSelected = sessionStorage.getItem("selected");
  if (!currentSelected) {
    blogTagBtns[0].classList.add("m-link-list--item-selected");
    sessionStorage.setItem("selected", blogTagBtns[0].id);
  } else {
    const btnId = sessionStorage.getItem("selected");
    blogTagBtns.forEach((tag) => {
      if (tag.id === btnId) {
        tag.classList.add("m-link-list--item-selected");
      }
    });
  }

  parentList.addEventListener("click", (e) => {
    let targetItem = e.target.classList.contains("m-link-lists--item-blog")
      ? e.target
      : e.target.closest(".m-link-lists--item-blog");

    if (targetItem) {
      sessionStorage.setItem("selected", targetItem.id);
      blogTagBtns.forEach((tag) => {
        tag.classList.remove("m-link-list--item-selected");
      });
      targetItem.classList.add("m-link-list--item-selected");
      const link = targetItem.querySelector("a");
      if (link) {
        // Simulate a click on the link to navigate
        link.click();
      }
    }
  });
});
